module.exports = __webpack_public_path__ + "static/media/emma-stone.eed01558.jpg";